import React from "react";
import "./attachmentContainer.css";

/**
 * 첨부 컨테이너 — 1열·3열 동일 스택 UI (레인 단위로 쌓임)
 */
export function AttachmentContainer({className = "", children}) {
    return (
        <section className={`attch ${className}`.trim()}>
            <div className="attch__body">{children}</div>
        </section>
    );
}

/**
 * 파일 / 이미지 레인
 */
export function AttachmentLane({label, variant = "file", count = 0, children}) {
    return (
        <div className={`attch-lane attch-lane--${variant}`}>
            {label ? (
                <div className="attch-lane__label-row">
                    <span className="attch-lane__label">{label}</span>
                    {count > 0 ? <span className="attch-lane__count">{count}</span> : null}
                </div>
            ) : null}
            <div className="attch-lane__main">{children}</div>
        </div>
    );
}
